/* eslint-disable simple-import-sort/imports */
import "~/config/sentry.config";

import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "src/App";

import { registerDynamicImportRecovery } from "~/utils/dynamicImportRecovery";

registerDynamicImportRecovery();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
